/**
 * Login with Google OAuth
 * @param next - Optional path to redirect to after successful authentication
 */
export async function loginWithGoogle(next?: string) {
  const supabase = useSupabaseClient()
  
  // Dynamic callback domain based on current window location
  const callbackDomain = window.location.origin
  
  // Build the callback URL with optional next parameter
  let callbackUrl = `${callbackDomain}/auth/callback`
  if (next && typeof next === 'string' && next.startsWith('/')) {
    callbackUrl += `?next=${encodeURIComponent(next)}`
  }
  
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      scopes: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/drive.file',
      redirectTo: callbackUrl,
      queryParams: {
        access_type: 'offline',
        prompt: 'consent',
      },
    },
  })
  error ? console.error(error) : console.log(data.url)
}

export async function logout() {
  const supabase = useSupabaseClient()
  await supabase.auth.signOut()
  await navigateTo('/')
}
